import { render, staticRenderFns } from "./TMIP.vue?vue&type=template&id=a38c40fe&scoped=true&"
import script from "./TMIP.vue?vue&type=script&lang=js&"
export * from "./TMIP.vue?vue&type=script&lang=js&"
import style0 from "./TMIP.vue?vue&type=style&index=0&id=a38c40fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38c40fe",
  null
  
)

export default component.exports